import { render, staticRenderFns } from "./NotificationOverview.vue?vue&type=template&id=7552f26c&scoped=true"
import script from "./NotificationOverview.vue?vue&type=script&lang=ts"
export * from "./NotificationOverview.vue?vue&type=script&lang=ts"
import style0 from "./NotificationOverview.vue?vue&type=style&index=0&id=7552f26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552f26c",
  null
  
)

export default component.exports